module.exports = __webpack_public_path__ + "static/media/application-lits.880a9a75.svg";